import {
  Divider,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import PagesContainer from "../../../components/UI/PagesContainer";
import { useTranslation } from "react-i18next";
import EmergencyCareService from "../../../services/emergencyCare.service";
import { useCallback, useEffect, useState } from "react";
import { IBeneficiaries, IBeneficiaryData } from "../../../models/topmed";
import { useFetch } from "@4uhub/lib4uhub";
import { SelectBeneficiaryCard } from "../../../components/UI/SelectBeneficiaryCard/SelectBeneficiaryCard";
import { topmedScheduleRegisterPerson } from "../../../services/topmedSchedule.service";
import { useNavigate } from "react-router-dom";

const translationPath = "page.topmedSchedule.newSchedule.";

const beneficiariesService = new EmergencyCareService();

const NewTopMedSchedule = () => {
  const { t } = useTranslation();

  const [beneficiaries, setBeneficiaries] = useState<IBeneficiaries>();

  const navigate = useNavigate();

  const theme = useTheme();

  const matches = useMediaQuery(theme.breakpoints.up("md"));

  const { sendRequest, loading } = useFetch(
    beneficiariesService.getElectiveBeneficiaries
  );

  const { sendRequest: register, loading: rLoading } = useFetch(
    topmedScheduleRegisterPerson
  );

  const selectPersonHandler = useCallback(
    async (beneficiary: IBeneficiaryData) => {
      const { success } = await register(beneficiary.beneficiaryId);
      if (success) {
        navigate(beneficiary.beneficiaryId);
      }
    },
    [register, navigate]
  );

  const loadBeneficiaries = useCallback(async () => {
    const { data, success } = await sendRequest(null);
    if (data && success) {
      setBeneficiaries(data);
    }
  }, [sendRequest]);

  useEffect(() => {
    loadBeneficiaries();
  }, [loadBeneficiaries]);

  const hasDependents =
    beneficiaries?.dependents && beneficiaries?.dependents.length !== 0;

  return (
    <PagesContainer
      redirectTo={"/schedule-teleconsultation/topmed-schedule"}
      title={t(translationPath + "title")}
      loading={loading}
    >
      <Grid item sm={12} mb={2} display={"flex"} alignItems={"center"} gap={2}>
        <Typography
          variant="h6"
          sx={(theme) => ({
            color:
              theme.palette.mode === "light"
                ? theme.palette.grey[700]
                : theme.palette.grey[400],
          })}
          lineHeight={1.2}
        >
          {t(translationPath + "choose_patient")}
        </Typography>
      </Grid>

      {beneficiaries && (
        <>
          <Grid item sm={12} mb={2}>
            <Grid container gap={2}>
              <Grid item xs={12} md={12} sm={6} lg={4}>
                <SelectBeneficiaryCard
                  padding={matches ? 2 : 1}
                  beneficiary={beneficiaries.currentUser}
                  onClick={selectPersonHandler}
                  loading={rLoading}
                />
              </Grid>
            </Grid>
          </Grid>
          {hasDependents && (
            <>
              <Divider />
              <Grid item sm={12} mt={2}>
                <Typography variant="h6" mb={1}>
                  {t(translationPath + "dependents")}
                </Typography>
                <Stack
                  display={"flex"}
                  flexDirection={"row"}
                  flexWrap={"wrap"}
                  gap={2}
                >
                  {beneficiaries.dependents.map((dependent) => (
                    <SelectBeneficiaryCard
                      padding={matches ? 2 : 1}
                      beneficiary={dependent}
                      key={dependent.beneficiaryId}
                      onClick={selectPersonHandler}
                      loading={rLoading}
                    />
                  ))}
                </Stack>
              </Grid>
            </>
          )}
        </>
      )}
    </PagesContainer>
  );
};

export default NewTopMedSchedule;
